export const millings = {
    'Moenda 4 ternos': { 
        name: 'Moenda 4 ternos', 
        idImg:'moenda4', 
        image: 'Moenda_4_ternos.png',
        colorConn: '#683604'
     },
    'Moenda 5 ternos': { 
        name: 'Moenda 5 ternos', 
        idImg:'moenda5', 
        image: 'Moenda_5_ternos.png',
        colorConn: '#683604'
    },
    'Moenda 6 ternos': { 
        name: 'Moenda 6 ternos', 
        idImg:'moenda6', 
        image: 'Moenda_6_ternos.png',
        colorConn: '#683604'
    },
}